<template>
  <div>
    <section style="background: #fff; padding: 40px">
      <div style="text-align: center">
        <h2 style="margin-bottom: 0; font-size: 40px; font-weight: bold">
          {{ block.title }}
        </h2>
        <img src="/img/teal-line.svg" class="mb20 mt20" />
      </div>
      <div class="fort-body">
        <div v-html="block.body"></div>
      </div>
    </section>
    <divider v-if="block.BottomDivider" />
  </div>
</template>
  
  <script>
import Divider from "@/components/FortBuilder/Divider.vue";
export default {
  name: "ScoreCard",
  data() {
    return {
      anniversaries: [
        {
          time: "20",
          name: "Patterson Pope",
        },
        {
          time: "32",
          name: "Heritage Business Interiors",
        },
        {
          time: "36",
          name: "The Systemcenter Inc.",
        },
        {
          time: "28",
          name: "Ergo Office Plus",
        },
        {
          time: "29",
          name: "STORAGELogic",
        },
      ],
    };
  },
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
  components: {
    Divider,
  },
  methods: {},
};
</script>
  
  <style scoped>
</style>















